import { SVGProps } from "react";

export const CardViewIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="#000"
        d="M4.5 4.75A2.75 2.75 0 0 0 1.75 7.5v1a2.75 2.75 0 0 0 2.75 2.75h4a2.75 2.75 0 0 0 2.75-2.75v-1A2.75 2.75 0 0 0 8.5 4.75zM3.25 7.5c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25zm1.25 5.25a2.75 2.75 0 0 0-2.75 2.75v1a2.75 2.75 0 0 0 2.75 2.75h4a2.75 2.75 0 0 0 2.75-2.75v-1a2.75 2.75 0 0 0-2.75-2.75zM3.25 15.5c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25zm9.5 0a2.75 2.75 0 0 1 2.75-2.75h4a2.75 2.75 0 0 1 2.75 2.75v1a2.75 2.75 0 0 1-2.75 2.75h-4a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v1c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-1c0-.69-.56-1.25-1.25-1.25zm0-9.5a2.75 2.75 0 0 0-2.75 2.75v1a2.75 2.75 0 0 0 2.75 2.75h4a2.75 2.75 0 0 0 2.75-2.75v-1a2.75 2.75 0 0 0-2.75-2.75zM14.25 7.5c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25h-4c-.69 0-1.25-.56-1.25-1.25z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  );
};
